const burger = document.getElementById('burger-btn');
const mobileMenu = document.querySelector('.nav');
const links = document.querySelectorAll('.nav a');
const closeMobileMenuBtn = document.getElementById('close-mobile-menu');
const body = document.body;

function toggleMobileMenu(isOpen) {
  mobileMenu.classList.toggle('active', isOpen);
  body.classList.toggle('body-no-scroll', isOpen);
  burger.setAttribute('aria-expanded', isOpen);
}

burger.addEventListener('click', () => {
  const isOpen = !mobileMenu.classList.contains('active');
  toggleMobileMenu(isOpen);
});

closeMobileMenuBtn.addEventListener('click', () => {
  toggleMobileMenu(false);
});

links.forEach(link => {
  link.addEventListener('click', () => toggleMobileMenu(false));
});
